import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/omnitecActions'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

export const fetchOmnitecEasymsCategories = organizationId => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_EASYMS_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urls.easymsCategories(organizationId), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_fetchEasymsCategoriesSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_fetchEasymsCategoriesFailure,
                'Что-то пошло не так!',
                'При получении замков произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/omnitecApi/omnitecEasyms.js